import { c as _c } from "react/compiler-runtime";
import React from 'react';
import IconCheck from '@/assets/icons/heroIcons/Circle-check-empty.svg';
import IconCross from '@/assets/icons/heroIcons/Circle-cross-empty.svg';
import { mergeClasses } from '@/utils/style';
export function OrderedList(t0) {
  const $ = _c(7);
  const {
    items,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = mergeClasses("flex flex-col gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items) {
    t2 = items.map(_temp);
    $[2] = items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <ol className={t1}>{t2}</ol>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(item, i) {
  return <li key={i} className="flex items-start gap-3 text-sm whitespace-normal lg:text-base"><span className="flex h-5 w-5 shrink-0 grow-0 basis-5 items-center justify-center rounded-full bg-blue-800 text-xs font-semibold text-white lg:h-6 lg:w-6 lg:basis-6 lg:text-sm">{i + 1}</span><span>{item}</span></li>;
}
export function UnorderedList(t0) {
  const $ = _c(7);
  const {
    items,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = mergeClasses("flex flex-col gap-2 pl-6 marker:text-blue-500", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items) {
    t2 = items.map(_temp2);
    $[2] = items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <ul className={t1}>{t2}</ul>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp2(item, i) {
  return <li key={i} className="list-disc pl-2 text-sm whitespace-normal lg:text-base">{item}</li>;
}
export function PropsConsList(t0) {
  const $ = _c(10);
  const {
    items,
    variant,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = mergeClasses("flex flex-col gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items || $[3] !== variant) {
    let t3;
    if ($[5] !== variant) {
      t3 = (item, i) => <li key={i} className="flex items-start gap-2 text-sm whitespace-normal lg:text-base"><span className={mergeClasses("iconContainer flex h-5 w-5 shrink-0 grow-0 basis-5 items-center justify-center rounded-full lg:h-6 lg:w-6 lg:basis-6 lg:text-sm", variant === "props" ? "text-green-500" : "text-red-500")}>{variant === "props" ? <IconCheck /> : <IconCross />}</span><span>{item}</span></li>;
      $[5] = variant;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = items.map(t3);
    $[2] = items;
    $[3] = variant;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <ol className={t1}>{t2}</ol>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
export function TagsList(t0) {
  const $ = _c(7);
  const {
    items,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = mergeClasses("mt-6 grid grid-cols-2 gap-2 lg:mt-5 lg:grid-cols-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items) {
    t2 = items.map(_temp3);
    $[2] = items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp3(item, i) {
  return <div key={i} className="rounded-lg bg-blue-100 p-3 text-sm font-semibold lg:px-4 lg:text-base">{item}</div>;
}